import LoginModal from "./LoginModal";
import RegisterModal from "./RegisterModal";
import ForgotPasswordModal from "./ForgotPasswordModal";
import VerifyOtpModal from "./VerifyOtpModal";
import ResetPasswordModal from "./ResetPasswordModal";
import { useModal } from "../hooks/ModalContext";

export default function ModalContainer() {
  const { activeModal, setActiveModal, emailForOtp, passwordForOtp } = useModal();

  return (
    <>
      <LoginModal
        isActive={activeModal === "login"}
        onClose={() => setActiveModal(null)}
        onForgotPassword={() => setActiveModal("forgotPassword")}
        onRegister={() => setActiveModal("register")}
        onVerifyOtp={() => setActiveModal("verifyOtp")}
        emailForOtp={emailForOtp}
      />

      <RegisterModal
        isActive={activeModal === "register"}
        onClose={() => setActiveModal(null)}
        onVerifyOtp={() => setActiveModal("verifyOtp")}
        onLogin={() => setActiveModal("login")}
      />

      <ForgotPasswordModal
        isActive={activeModal === "forgotPassword"}
        onClose={() => setActiveModal(null)}
        onVerifyOtp={() => setActiveModal("verifyOtp")}
      />

      <VerifyOtpModal
        isActive={activeModal === "verifyOtp"}
        onClose={() => setActiveModal(null)}
        email={emailForOtp}
        onResetPassword={() => setActiveModal("resetPassword")}
        password={passwordForOtp}
      />

      <ResetPasswordModal
        id="resetPassword"
        isActive={activeModal === "resetPassword"}
        onClose={() => setActiveModal(null)}
        email={emailForOtp}
      />
    </>
  );
}
